import compact from "lodash/compact";
import pluralize from "lib/pluralize";

const READING_FORMATS = {
  1: "Read",
  2: "Listen to",
  3: "Read + Listen to",
};

const BOOK_TYPES = {
  1: "book",
  2: "short story",
  3: "graphic novel",
};
const AUTHOR_GENDERS = {
  1: "male",
  2: "woman",
  3: "trans",
};
const AUTHOR_RACES = {
  1: "white",
  2: "black",
  3: "asian",
  4: "chinese",
  5: "middle eastern",
};
const AUTHOR_ORIENTATION = {
  1: "heterosexual",
  2: "lgbtq+",
};

const goalTitlizer = (goal) => {
  // Reading Format
  let readingFormat;
  /* eslint no-underscore-dangle: 0 */
  if (goal.conditions.readingFormatId) {
    readingFormat = READING_FORMATS[goal.conditions.readingFormatId];
  } else {
    readingFormat = "Read";
  }

  // Book Type
  let bookType;
  const count =
    goal.metric === "page"
      ? `${Math.round(goal.goal / 1000)}k`
      : Math.floor(goal.goal).toLocaleString();
  if (goal.conditions?.listId) {
    bookType = `${count} ${pluralize(goal.metric, goal.goal)} from ${
      goal.listTitle
    }`;
  } else if (goal.conditions?.type) {
    bookType = `${count} ${
      goal.conditions.type.length > 1
        ? pluralize(BOOK_TYPES[goal.conditions.type], goal.goal)
        : pluralize(goal.metric, goal.goal)
    }`;
  } else {
    bookType = `${count} ${pluralize(goal.metric, goal.goal)}`;
  }

  // Author
  const author = [];
  let authors = "";
  if (goal.conditions?.book?.author) {
    const authorCond = goal.conditions.book.author;

    // Author Race
    if (authorCond.raceId?._eq) {
      author.push(
        `<span class="font-semibold text-gray-200">${
          AUTHOR_RACES[authorCond.raceId?._eq]
        }</span>`
      );
    }

    // Author Sexual Orientation
    if (authorCond.sexOrientationId?._eq) {
      author.push(
        `<span class="font-semibold text-gray-200">${
          AUTHOR_ORIENTATION[authorCond.sexOrientationId?._eq]
        }</span>`
      );
    }

    // Author Gender
    if (authorCond.genderId?._eq) {
      author.push(
        `<span class="font-semibold text-gray-200">${
          AUTHOR_GENDERS[authorCond.genderId?._eq]
        }</span>`
      );
    }

    if (author.length > 0) {
      authors = `by ${compact(author).join(", ")} author${
        goal.count > 1 ? "s" : ""
      }`;
    }
  }

  // Date
  let dateText = "";
  const startDate = new Date(`${goal.startDate}T00:00:00`);
  const endDate = new Date(`${goal.endDate}T00:00:00`);
  if (
    startDate.getFullYear() === endDate.getFullYear() - 1 &&
    startDate.getMonth() === 0 &&
    startDate.getDate() === 1 &&
    endDate.getMonth() === 0 &&
    endDate.getDate() === 1
  ) {
    dateText = `in ${startDate.getFullYear()}`;
  } else {
    dateText = `by ${endDate.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })}`;
  }

  return compact([readingFormat, bookType, authors, dateText]).join(" ");
};

export default goalTitlizer;
